import * as Yup from "yup";

export const validationSchema = (infoData, requiredMessage) =>
  Yup.object({
    email: Yup.string()
      .email(infoData.email?.emailFormat)
      .required(requiredMessage),
    phone: Yup.string()
      .matches(/^(009665|\+9665|05)\d{8}$/, infoData.phone?.phoneFormat)
      .required(requiredMessage),
    password: Yup.string()
      .nullable()
      .when([], {
        is: (val) => val && val.length > 0,
        then: (schema) =>
          schema.min(
            8,
            infoData.password?.passwordFormat ||
              "Password must be at least 8 characters"
          ),
        otherwise: (schema) => schema,
      }),
  });
